import { render, staticRenderFns } from "./FormulaLibraryDetail.vue?vue&type=template&id=12059b40"
import script from "./FormulaLibraryDetail.vue?vue&type=script&lang=js"
export * from "./FormulaLibraryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports